// AUTO-GENERERAD av scripts/gen-content-dates.ts — redigera inte för hand.
// Sanna lastmod-datum härledda från git-historiken per routefil.

export const CONTENT_DATES: Record<string, string> = {
  "/": "2026-07-09",
  "/3d-animation": "2026-06-17",
  "/aftermovie": "2026-06-17",
  "/animerad-forklaringsfilm": "2026-06-17",
  "/animerad-reklamfilm": "2026-06-17",
  "/b-roll-inspelning": "2026-06-17",
  "/b2b-video": "2026-06-17",
  "/branscher/bygg": "2026-06-17",
  "/branscher/e-handel": "2026-06-17",
  "/branscher/fastighet": "2026-06-17",
  "/branscher/halsa": "2026-06-17",
  "/branscher/industri": "2026-06-17",
  "/branscher/offentlig-sektor": "2026-06-17",
  "/branscher/restaurang": "2026-06-17",
  "/branscher/saas": "2026-06-17",
  "/branscher/video-for-b2b": "2026-06-17",
  "/branscher/video-for-marknadsavdelningar": "2026-06-17",
  "/branscher/video-for-saljteam": "2026-06-17",
  "/branscher/video-for-tillvaxtbolag": "2026-06-17",
  "/branschstudier": "2026-06-23",
  "/branschstudier/produktfilm": "2026-06-23",
  "/brollopsfilm": "2026-07-09",
  "/case": "2026-07-09",
  "/casting-skadespelare": "2026-06-17",
  "/contentbyra": "2026-06-17",
  "/dokumentarfilm": "2026-06-17",
  "/dronarfilm": "2026-06-17",
  "/employer-branding-film": "2026-06-17",
  "/employer-branding-film/boras": "2026-05-20",
  "/employer-branding-film/eskilstuna": "2026-05-20",
  "/employer-branding-film/gavle": "2026-05-20",
  "/employer-branding-film/goteborg": "2026-05-20",
  "/employer-branding-film/halmstad": "2026-05-20",
  "/employer-branding-film/helsingborg": "2026-05-20",
  "/employer-branding-film/jonkoping": "2026-05-20",
  "/employer-branding-film/karlstad": "2026-05-20",
  "/employer-branding-film/linkoping": "2026-05-20",
  "/employer-branding-film/lulea": "2026-05-20",
  "/employer-branding-film/lund": "2026-05-20",
  "/employer-branding-film/malmo": "2026-05-20",
  "/employer-branding-film/norrkoping": "2026-05-20",
  "/employer-branding-film/orebro": "2026-05-20",
  "/employer-branding-film/solna": "2026-05-20",
  "/employer-branding-film/stockholm": "2026-05-20",
  "/employer-branding-film/sundsvall": "2026-05-20",
  "/employer-branding-film/umea": "2026-05-20",
  "/employer-branding-film/uppsala": "2026-05-20",
  "/employer-branding-film/vasteras": "2026-05-20",
  "/employer-branding-film/vaxjo": "2026-05-20",
  "/en": "2026-06-17",
  "/en/3d-animation": "2026-05-20",
  "/en/about": "2026-06-17",
  "/en/ad-agency": "2026-05-20",
  "/en/aftermovie": "2026-05-20",
  "/en/agency-vs-freelancer": "2026-05-20",
  "/en/b-roll": "2026-05-20",
  "/en/brand-film": "2026-05-20",
  "/en/campaign-film": "2026-05-20",
  "/en/commercials": "2026-05-20",
  "/en/contact": "2026-07-13",
  "/en/content-agency": "2026-05-20",
  "/en/corporate-video": "2026-05-20",
  "/en/customer-story-video": "2026-05-20",
  "/en/documentary": "2026-05-20",
  "/en/employer-branding-video": "2026-05-20",
  "/en/event-film": "2026-05-20",
  "/en/faq": "2026-05-20",
  "/en/film-agency": "2026-05-20",
  "/en/film-producer": "2026-05-20",
  "/en/film-production": "2026-05-20",
  "/en/film-production-sweden": "2026-06-17",
  "/en/for-journalists": "2026-05-20",
  "/en/glossary": "2026-05-20",
  "/en/heritage": "2026-06-07",
  "/en/heritage/kunskapsarv": "2026-06-07",
  "/en/heritage/livsberattelser": "2026-06-07",
  "/en/how-long-should-a-commercial-be": "2026-05-20",
  "/en/image-film": "2026-05-20",
  "/en/industries/construction": "2026-05-29",
  "/en/industries/ecommerce": "2026-05-29",
  "/en/industries/health": "2026-05-29",
  "/en/industries/industry": "2026-05-29",
  "/en/industries/public-sector": "2026-05-29",
  "/en/industries/real-estate": "2026-05-29",
  "/en/industries/restaurant": "2026-05-29",
  "/en/industries/saas": "2026-05-29",
  "/en/inhouse-vs-agency": "2026-05-20",
  "/en/instructional-video": "2026-05-20",
  "/en/internal-communication-video": "2026-05-20",
  "/en/knowledge": "2026-06-17",
  "/en/live-streaming": "2026-05-20",
  "/en/motion-graphics": "2026-05-20",
  "/en/partners": "2026-05-20",
  "/en/podcast-video": "2026-05-20",
  "/en/press": "2026-05-20",
  "/en/press/commercial-2026-report": "2026-05-20",
  "/en/pricing": "2026-06-26",
  "/en/prime": "2026-08-07",
  "/en/privacy": "2026-05-20",
  "/en/process": "2026-06-17",
  "/en/product-video": "2026-05-20",
  "/en/pulse": "2026-06-23",
  "/en/pulse-vs-prime": "2026-05-20",
  "/en/questions": "2026-06-17",
  "/en/recruitment-video": "2026-05-20",
  "/en/reports/commercial-2026": "2026-05-20",
  "/en/services": "2026-06-23",
  "/en/social-media-video": "2026-05-20",
  "/en/subscription-video": "2026-05-20",
  "/en/subscription-vs-project": "2026-05-20",
  "/en/testimonial-video": "2026-05-20",
  "/en/training-video": "2026-05-20",
  "/en/video-agency": "2026-05-20",
  "/en/video-agency-stockholm": "2026-06-17",
  "/en/video-for-b2b": "2026-05-28",
  "/en/video-for-growth-companies": "2026-05-28",
  "/en/video-for-instagram": "2026-05-20",
  "/en/video-for-linkedin": "2026-05-20",
  "/en/video-for-marketing-teams": "2026-05-28",
  "/en/video-for-sales-teams": "2026-05-28",
  "/en/video-for-tiktok": "2026-05-20",
  "/en/video-for-youtube": "2026-05-20",
  "/en/video-price-calculator": "2026-05-20",
  "/en/video-production": "2026-05-20",
  "/en/video-subscription": "2026-05-20",
  "/en/what-does-a-commercial-cost": "2026-05-20",
  "/en/what-does-a-corporate-video-cost": "2026-05-20",
  "/en/why-video": "2026-06-17",
  "/en/work": "2026-06-17",
  "/english/film-production-sweden": "2026-06-17",
  "/english/video-agency-stockholm": "2026-06-17",
  "/eventfilm": "2026-06-17",
  "/explainer-video": "2026-06-17",
  "/faq": "2026-07-13",
  "/film-for-instagram": "2026-06-17",
  "/film-for-linkedin": "2026-06-17",
  "/film-for-tiktok": "2026-06-17",
  "/film-for-youtube": "2026-06-17",
  "/film-pa-prenumeration": "2026-06-21",
  "/film-pris-kalkyl": "2026-07-05",
  "/filmabonnemang": "2026-06-21",
  "/filmbyra": "2026-06-17",
  "/filmbyra/boras": "2026-06-17",
  "/filmbyra/eskilstuna": "2026-06-17",
  "/filmbyra/gavle": "2026-06-17",
  "/filmbyra/goteborg": "2026-07-13",
  "/filmbyra/halmstad": "2026-06-17",
  "/filmbyra/helsingborg": "2026-06-17",
  "/filmbyra/jonkoping": "2026-06-17",
  "/filmbyra/karlstad": "2026-06-17",
  "/filmbyra/linkoping": "2026-06-17",
  "/filmbyra/lulea": "2026-06-17",
  "/filmbyra/lund": "2026-06-17",
  "/filmbyra/malmo": "2026-06-17",
  "/filmbyra/norrkoping": "2026-06-17",
  "/filmbyra/orebro": "2026-06-17",
  "/filmbyra/solna": "2026-06-17",
  "/filmbyra/stockholm": "2026-07-13",
  "/filmbyra/sundsvall": "2026-06-17",
  "/filmbyra/umea": "2026-06-17",
  "/filmbyra/uppsala": "2026-06-17",
  "/filmbyra/vasteras": "2026-06-17",
  "/filmbyra/vaxjo": "2026-06-17",
  "/filmproducent": "2026-06-17",
  "/filmproduktion": "2026-06-17",
  "/filmproduktion-mellansverige": "2026-06-17",
  "/filmproduktion-sverige": "2026-06-17",
  "/filmproduktion/boras": "2026-06-17",
  "/filmproduktion/eskilstuna": "2026-06-17",
  "/filmproduktion/gavle": "2026-06-17",
  "/filmproduktion/goteborg": "2026-07-05",
  "/filmproduktion/halmstad": "2026-06-17",
  "/filmproduktion/helsingborg": "2026-06-17",
  "/filmproduktion/jonkoping": "2026-06-17",
  "/filmproduktion/karlstad": "2026-06-17",
  "/filmproduktion/linkoping": "2026-06-17",
  "/filmproduktion/lulea": "2026-06-17",
  "/filmproduktion/lund": "2026-06-17",
  "/filmproduktion/malmo": "2026-07-05",
  "/filmproduktion/norrkoping": "2026-06-17",
  "/filmproduktion/orebro": "2026-06-17",
  "/filmproduktion/solna": "2026-06-17",
  "/filmproduktion/stockholm": "2026-07-05",
  "/filmproduktion/sundsvall": "2026-06-17",
  "/filmproduktion/umea": "2026-06-17",
  "/filmproduktion/uppsala": "2026-06-17",
  "/filmproduktion/vasteras": "2026-06-17",
  "/filmproduktion/vaxjo": "2026-06-17",
  "/for-journalister": "2026-06-23",
  "/for-vem": "2026-06-17",
  "/foretagsfilm": "2026-06-17",
  "/foretagsfilm/boras": "2026-06-17",
  "/foretagsfilm/eskilstuna": "2026-06-17",
  "/foretagsfilm/gavle": "2026-06-17",
  "/foretagsfilm/goteborg": "2026-06-17",
  "/foretagsfilm/halmstad": "2026-06-17",
  "/foretagsfilm/helsingborg": "2026-06-17",
  "/foretagsfilm/jonkoping": "2026-06-17",
  "/foretagsfilm/karlstad": "2026-06-17",
  "/foretagsfilm/linkoping": "2026-06-17",
  "/foretagsfilm/lulea": "2026-06-17",
  "/foretagsfilm/lund": "2026-06-17",
  "/foretagsfilm/malmo": "2026-06-17",
  "/foretagsfilm/norrkoping": "2026-06-17",
  "/foretagsfilm/orebro": "2026-06-17",
  "/foretagsfilm/solna": "2026-06-17",
  "/foretagsfilm/stockholm": "2026-06-17",
  "/foretagsfilm/sundsvall": "2026-06-17",
  "/foretagsfilm/umea": "2026-06-17",
  "/foretagsfilm/uppsala": "2026-06-17",
  "/foretagsfilm/vasteras": "2026-06-17",
  "/foretagsfilm/vaxjo": "2026-06-17",
  "/formatguide-2026": "2026-06-17",
  "/fragor": "2026-06-17",
  "/guider": "2026-06-17",
  "/heritage": "2026-06-13",
  "/heritage/goteborg": "2026-06-08",
  "/heritage/kunskapsarv": "2026-06-07",
  "/heritage/livsberattelser": "2026-06-07",
  "/heritage/malmo": "2026-06-08",
  "/heritage/stockholm": "2026-06-08",
  "/heritage/uppsala": "2026-06-08",
  "/hur-lang-ska-en-reklamfilm-vara": "2026-06-17",
  "/imagefilm": "2026-06-17",
  "/instruktionsfilm": "2026-06-17",
  "/integritet": "2026-06-21",
  "/internkommunikation-film": "2026-06-17",
  "/jamfor/fenny-vs-andeox": "2026-05-28",
  "/jamfor/fenny-vs-brandfixers": "2026-05-28",
  "/jamfor/fenny-vs-colibri-content": "2026-05-28",
  "/jamfor/fenny-vs-filmbyran": "2026-05-28",
  "/jamfor/fenny-vs-filmmakeriet": "2026-05-28",
  "/jamfor/fenny-vs-klara-fardiga-film": "2026-05-28",
  "/jamfor/fenny-vs-parable": "2026-05-28",
  "/jamfor/fenny-vs-social-cut": "2026-05-28",
  "/jamfor/fenny-vs-streamrocket": "2026-05-28",
  "/jamfor/fenny-vs-street-studios": "2026-05-28",
  "/jamfor/film-pa-abonnemang-vs-filmbyra": "2026-05-28",
  "/jamfor/filmabonnemang-vs-projektfilm": "2026-06-17",
  "/jamfor/filmbyra-vs-frilansare": "2026-06-17",
  "/jamfor/filmproduktion-abonnemang-vs-projektpris": "2026-05-28",
  "/jamfor/inhouse-vs-filmbyra": "2026-06-17",
  "/jamfor/kunskapsoverforing-vs-process-dokumentation": "2026-06-08",
  "/jamfor/livsberattelse-pa-film-vs-memoarbok": "2026-06-08",
  "/jamfor/pulse-vs-prime": "2026-07-05",
  "/jamfor/video-as-a-service-vs-filmbyra": "2026-05-28",
  "/jamfor/videoabonnemang-vs-contentabonnemang": "2026-05-28",
  "/kampanjfilm": "2026-06-17",
  "/kontakt": "2026-07-13",
  "/kortformat-film": "2026-06-17",
  "/kundcase-film": "2026-06-17",
  "/kunskap": "2026-06-17",
  "/livesandning": "2026-06-17",
  "/motion-graphics": "2026-06-17",
  "/om-fenny": "2026-07-13",
  "/ordlista": "2026-06-17",
  "/partners": "2026-06-26",
  "/pilot": "2026-07-13",
  "/podcast-video": "2026-06-17",
  "/press": "2026-06-23",
  "/press/reklamfilm-2026-rapport": "2026-06-23",
  "/prime": "2026-06-23",
  "/pris": "2026-08-07",
  "/pris/animerad-film": "2026-05-28",
  "/pris/employer-branding-film": "2026-05-28",
  "/pris/filmabonnemang": "2026-05-28",
  "/pris/filmproduktion": "2026-05-28",
  "/pris/kunskapsoverforing": "2026-06-07",
  "/pris/livsberattelse-film": "2026-06-07",
  "/pris/produktfilm": "2026-05-28",
  "/pris/sociala-medier-film": "2026-05-28",
  "/pris/videoproduktion": "2026-05-28",
  "/priser": "2026-07-13",
  "/process": "2026-06-17",
  "/produktfilm": "2026-06-17",
  "/produktionsbolag-film": "2026-06-17",
  "/produktionsbolag/boras": "2026-07-05",
  "/produktionsbolag/eskilstuna": "2026-07-05",
  "/produktionsbolag/gavle": "2026-07-05",
  "/produktionsbolag/goteborg": "2026-07-05",
  "/produktionsbolag/halmstad": "2026-07-05",
  "/produktionsbolag/helsingborg": "2026-07-05",
  "/produktionsbolag/jonkoping": "2026-07-05",
  "/produktionsbolag/karlstad": "2026-07-05",
  "/produktionsbolag/linkoping": "2026-07-05",
  "/produktionsbolag/lulea": "2026-07-05",
  "/produktionsbolag/lund": "2026-07-05",
  "/produktionsbolag/malmo": "2026-07-05",
  "/produktionsbolag/norrkoping": "2026-07-05",
  "/produktionsbolag/orebro": "2026-07-05",
  "/produktionsbolag/solna": "2026-07-05",
  "/produktionsbolag/stockholm": "2026-07-05",
  "/produktionsbolag/sundsvall": "2026-07-05",
  "/produktionsbolag/umea": "2026-07-05",
  "/produktionsbolag/uppsala": "2026-07-05",
  "/produktionsbolag/vasteras": "2026-07-05",
  "/produktionsbolag/vaxjo": "2026-07-05",
  "/pulse": "2026-07-13",
  "/rapport/reklamfilm-2026": "2026-06-23",
  "/reklamfilm": "2026-07-05",
  "/reklamfilm/boras": "2026-06-17",
  "/reklamfilm/eskilstuna": "2026-06-17",
  "/reklamfilm/gavle": "2026-06-17",
  "/reklamfilm/goteborg": "2026-06-17",
  "/reklamfilm/halmstad": "2026-06-17",
  "/reklamfilm/helsingborg": "2026-06-17",
  "/reklamfilm/jonkoping": "2026-06-17",
  "/reklamfilm/karlstad": "2026-06-17",
  "/reklamfilm/linkoping": "2026-06-17",
  "/reklamfilm/lulea": "2026-06-17",
  "/reklamfilm/lund": "2026-06-17",
  "/reklamfilm/malmo": "2026-06-17",
  "/reklamfilm/norrkoping": "2026-06-17",
  "/reklamfilm/orebro": "2026-06-17",
  "/reklamfilm/solna": "2026-06-17",
  "/reklamfilm/stockholm": "2026-06-17",
  "/reklamfilm/sundsvall": "2026-06-17",
  "/reklamfilm/umea": "2026-06-17",
  "/reklamfilm/uppsala": "2026-06-17",
  "/reklamfilm/vasteras": "2026-06-17",
  "/reklamfilm/vaxjo": "2026-06-17",
  "/reklamfilmsbyra": "2026-06-17",
  "/rekryteringsfilm": "2026-06-17",
  "/sociala-medier-film": "2026-06-17",
  "/testimonial-film": "2026-06-17",
  "/tjanster": "2026-06-23",
  "/utbildningsfilm": "2026-06-17",
  "/vad-kostar-en-foretagsfilm": "2026-06-17",
  "/vad-kostar-en-reklamfilm": "2026-06-17",
  "/varfor-film": "2026-06-17",
  "/varumarkesfilm": "2026-06-17",
  "/videobyra": "2026-06-17",
  "/videobyra/boras": "2026-07-05",
  "/videobyra/eskilstuna": "2026-07-05",
  "/videobyra/gavle": "2026-07-05",
  "/videobyra/goteborg": "2026-07-05",
  "/videobyra/halmstad": "2026-07-05",
  "/videobyra/helsingborg": "2026-07-05",
  "/videobyra/jonkoping": "2026-07-05",
  "/videobyra/karlstad": "2026-07-05",
  "/videobyra/linkoping": "2026-07-05",
  "/videobyra/lulea": "2026-07-05",
  "/videobyra/lund": "2026-07-05",
  "/videobyra/malmo": "2026-07-05",
  "/videobyra/norrkoping": "2026-07-05",
  "/videobyra/orebro": "2026-07-05",
  "/videobyra/solna": "2026-07-05",
  "/videobyra/stockholm": "2026-07-05",
  "/videobyra/sundsvall": "2026-07-05",
  "/videobyra/umea": "2026-07-05",
  "/videobyra/uppsala": "2026-07-05",
  "/videobyra/vasteras": "2026-07-05",
  "/videobyra/vaxjo": "2026-07-05",
  "/videoproduktion": "2026-06-17",
  "/videoproduktion-pa-abonnemang": "2026-05-29",
  "/videoproduktion-sverige": "2026-06-17",
  "/videoproduktion/boras": "2026-05-20",
  "/videoproduktion/eskilstuna": "2026-05-20",
  "/videoproduktion/gavle": "2026-05-20",
  "/videoproduktion/goteborg": "2026-07-05",
  "/videoproduktion/halmstad": "2026-05-20",
  "/videoproduktion/helsingborg": "2026-05-20",
  "/videoproduktion/jonkoping": "2026-05-20",
  "/videoproduktion/karlstad": "2026-05-20",
  "/videoproduktion/linkoping": "2026-05-20",
  "/videoproduktion/lulea": "2026-05-20",
  "/videoproduktion/lund": "2026-05-20",
  "/videoproduktion/malmo": "2026-07-05",
  "/videoproduktion/norrkoping": "2026-05-20",
  "/videoproduktion/orebro": "2026-05-20",
  "/videoproduktion/solna": "2026-05-20",
  "/videoproduktion/stockholm": "2026-07-05",
  "/videoproduktion/sundsvall": "2026-05-20",
  "/videoproduktion/umea": "2026-05-20",
  "/videoproduktion/uppsala": "2026-05-20",
  "/videoproduktion/vasteras": "2026-05-20",
  "/videoproduktion/vaxjo": "2026-05-20",
  "/work": "2026-05-19"
};

export const CLUSTER_DATES: Record<string, string> = {
  "/fragor/": "2026-07-13",
  "/jamfor/": "2026-06-07",
  "/pris/": "2026-06-07",
  "/guider/": "2026-05-29",
  "/for-vem/": "2026-05-20",
  "/case/": "2026-05-20",
  "/prime/": "2026-05-22"
};
